import { Coins } from "lucide-react";

export const AiCost = ({ cost }) => {
  if (!cost) return <span data-testid="kit-ai-cost" className="inline-flex items-center gap-1.5 text-xs text-stone-400"><Coins size={12} /> AI cost not tracked (built before tracking)</span>;
  const parts = [["Writing", cost.writing], ["Web-checking", cost.web], ["Images", cost.images]].filter(([, v]) => v > 0);
  return (
    <span data-testid="kit-ai-cost" title={`${cost.calls} AI calls`} className="inline-flex flex-wrap items-center gap-1.5 text-xs text-stone-600">
      <Coins size={12} className="text-[#9A7B2C]" /> AI cost ≈ <b data-testid="kit-ai-cost-total" className="text-[#2B2A26]">${cost.total.toFixed(2)}</b>
      {parts.length > 0 && <span className="text-stone-400">({parts.map(([k, v]) => `${k} $${v.toFixed(2)}`).join(" · ")})</span>}
    </span>
  );
};
